module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/hidden-keys.js
// module id = 32
// module chunks = 0